import { Injectable } from '@angular/core';
import { AccountingEventsRepository } from '@core/repositories/accounting-events.repository';
import { AccountingEvent } from '@shared/interfaces/accounting-event';
import { Observable, of } from 'rxjs';

interface ResultAccountingEvent {
  id: number;
  attributes: {
    name: string;
  };
}

@Injectable({ providedIn: 'root' })
export class FakeAccountingEventsRepository
  implements AccountingEventsRepository {
  dataAccountingEvents: Array<ResultAccountingEvent> = [
    {
      id: 301,
      attributes: {
        name: 'Evento 3'
      }
    },
    {
      id: 401,
      attributes: {
        name: 'Evento 4'
      }
    },
    {
      id: 501,
      attributes: {
        name: 'Evento 5'
      }
    }
  ];

  rules = {
    data: this.dataAccountingEvents
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.rules);
  }

  add(rule: AccountingEvent): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(rule: AccountingEvent): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
